import { render } from "./PromptEnhancementManager.vue?vue&type=template&id=65d65d20&scoped=true"
import script from "./PromptEnhancementManager.vue?vue&type=script&lang=js"
export * from "./PromptEnhancementManager.vue?vue&type=script&lang=js"

import "./PromptEnhancementManager.vue?vue&type=style&index=0&id=65d65d20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d65d20"]])

export default __exports__